(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proof-approval"] && !Shopify.designMode) return;
  try {
    
  class ProofApprovalLightbox extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('.proof-approval-lightbox__image');
      this.closeTriggers = this.querySelectorAll('[data-lightbox-close]');
      this.lastFocused = null;

      this.closeTriggers.forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (event) => this.#handleKeyDown(event));
    }

    open(src, alt, trigger) {
      this.lastFocused = trigger || document.activeElement;
      this.image.src = src;
      this.image.alt = alt || '';
      this.removeAttribute('hidden');
      this.querySelector('.proof-approval-lightbox__close').focus();
      document.body.style.overflow = 'hidden';
    }

    close() {
      if (this.hasAttribute('hidden')) return;
      this.setAttribute('hidden', '');
      this.image.src = '';
      document.body.style.overflow = '';
      if (this.lastFocused instanceof HTMLElement) this.lastFocused.focus();
    }

    #handleKeyDown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;

      // Only the close button is focusable inside the dialog, so keep focus trapped on it.
      event.preventDefault();
      this.querySelector('.proof-approval-lightbox__close').focus();
    }
  }

  if (!customElements.get('proof-approval-lightbox')) {
    customElements.define('proof-approval-lightbox', ProofApprovalLightbox);
  }

  (() => {
    const DECISIONS = {
      approve: 'Approved',
      changes: 'Changes requested',
      decline: 'Not this one',
    };

    function init() {
      const form = document.getElementById('ProofApprovalForm');
      if (!form || form.dataset.proofReady === 'true') return;
      form.dataset.proofReady = 'true';

      const lightbox = document.querySelector('proof-approval-lightbox');
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-lightbox-src]');
        if (!trigger || !lightbox) return;
        lightbox.open(trigger.dataset.lightboxSrc, trigger.dataset.lightboxAlt, trigger);
      });

      const blocks = Array.from(form.querySelectorAll('[data-proof-block]'));
      const part = (block, selector) => block.querySelector(selector);
      const decisionOf = (block) => part(block, '[data-proof-decision-input]').value;
      const feedbackOf = (block) => part(block, '[data-proof-feedback]').value.trim();
      const labelOf = (block) => block.dataset.proofLabel || block.dataset.proofName || 'another option';
      const groupMembers = (block) => blocks.filter((b) => b.dataset.proofGroup === block.dataset.proofGroup);
      const siblingsOf = (block) => groupMembers(block).filter((b) => b !== block);

      // Sets one option's decision. decision is 'approve', 'changes', 'decline' or '' (none).
      // options.auto marks an option switched off because another option in its group was approved.
      function setDecision(block, decision, options = {}) {
        const auto = Boolean(options.auto);
        const approved = decision === 'approve';

        block.querySelectorAll('[data-decision]').forEach((btn) => {
          btn.setAttribute('aria-pressed', String(btn.dataset.decision === decision));
          if (auto) {
            btn.disabled = true;
          } else {
            btn.disabled = btn.dataset.decision === 'approve' && decision === 'decline';
          }
        });

        part(block, '[data-proof-decision-input]').value = decision ? DECISIONS[decision] : '';

        const signoff = part(block, '[data-proof-signoff]');
        const signedBy = part(block, '[data-proof-signed-by]');
        const attestation = part(block, '[data-proof-attestation]');
        signoff.hidden = !approved;
        signedBy.disabled = !approved;
        attestation.disabled = !approved;
        if (!approved) {
          signedBy.value = '';
          attestation.checked = false;
        }

        block.classList.toggle('proof-approval__block--declined', decision === 'decline');

        const autoBox = part(block, '[data-proof-auto]');
        if (auto) {
          block.dataset.autoDeclined = 'true';
          part(block, '[data-proof-auto-text]').textContent =
            'Not selected — you approved ' + options.because + ' for this product.';
          autoBox.hidden = false;
        } else {
          delete block.dataset.autoDeclined;
          autoBox.hidden = true;
        }

        setBlockError(block, '');
        setGroupError(block, '');
      }

      function approve(block) {
        setDecision(block, 'approve');
        siblingsOf(block).forEach((sibling) => {
          // Remember an option the client had already turned down themselves,
          // so withdrawing this approval restores that choice rather than clearing it.
          if (sibling.dataset.autoDeclined !== 'true') {
            sibling.dataset.ownChoice = decisionOf(sibling) === DECISIONS.decline ? 'decline' : '';
          }
          setDecision(sibling, 'decline', { auto: true, because: labelOf(block) });
        });
      }

      // When the approved option is withdrawn, options that were only switched off
      // because of it go back to what the client had chosen before (Not this one, or nothing).
      function releaseAutoDeclined(block) {
        siblingsOf(block).forEach((sibling) => {
          if (sibling.dataset.autoDeclined !== 'true') return;
          setDecision(sibling, sibling.dataset.ownChoice === 'decline' ? 'decline' : '');
          delete sibling.dataset.ownChoice;
        });
      }

      blocks.forEach((block) => {
        block.querySelectorAll('[data-decision]').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            const decision = button.dataset.decision;
            const wasApproved = decisionOf(block) === DECISIONS.approve;
            const alreadyPressed = button.getAttribute('aria-pressed') === 'true';

            if (decision === 'approve') {
              if (!alreadyPressed) approve(block);
              return;
            }

            // Clicking "Not this one" again clears it and makes Approve available again.
            setDecision(block, decision === 'decline' && alreadyPressed ? '' : decision);
            if (wasApproved) releaseAutoDeclined(block);
          });
        });

        const switchButton = part(block, '[data-proof-switch]');
        switchButton.addEventListener('click', () => {
          approve(block);
          part(block, '[data-proof-signed-by]').focus();
        });
      });

      function validateForm() {
        let firstInvalid = null;
        const flag = (el) => {
          if (!firstInvalid) firstInvalid = el;
        };

        blocks.forEach((block) => {
          const decision = decisionOf(block);
          let error = '';

          if (!decision) {
            error = 'Please choose "Approve as shown", "Request changes" or "Not this one" for this proof.';
          } else if (decision === DECISIONS.changes && feedbackOf(block) === '') {
            error = "Please describe the changes you'd like in the feedback field.";
          } else if (decision === DECISIONS.approve) {
            const signedBy = part(block, '[data-proof-signed-by]').value.trim();
            const confirmed = part(block, '[data-proof-attestation]').checked;
            if (signedBy === '' || !confirmed) error = 'Please enter your name and confirm the attestation checkbox.';
          }

          setBlockError(block, error);
          if (error) flag(block);
        });

        const seen = new Set();
        blocks.forEach((block) => {
          const key = block.dataset.proofGroup;
          if (seen.has(key)) return;
          seen.add(key);

          const members = groupMembers(block);
          const decisions = members.map(decisionOf);
          const approvedCount = decisions.filter((d) => d === DECISIONS.approve).length;
          const allDeclined = decisions.every((d) => d === DECISIONS.decline);
          const noFeedback = members.every((m) => feedbackOf(m) === '');
          let error = '';

          if (approvedCount > 1) {
            error = 'Please approve only one option for this product.';
          } else if (allDeclined && noFeedback) {
            error =
              members.length > 1
                ? 'You chose "Not this one" for every option. Please tell us what you would like instead in the feedback box of any option.'
                : 'Please tell us in the feedback box why this proof is not right, so we can revise it.';
          }

          setGroupError(block, error);
          if (error) flag(block.closest('[data-proof-group-wrapper]') || block);
        });

        return firstInvalid;
      }

      // v2.1: on submit, write the decisions as JSON into the Zoho web form's Submission Data
      // field (COBJ4CF4) and the email into Client Email (COBJ4CF3). The form itself is an
      // ordinary POST to Zoho, so delivery does not depend on background requests.
      function fillZohoFields() {
        const ctx = form.querySelector('[data-proof-context]');
        const emailEl = form.querySelector('#ProofApprovalEmail');
        const optOutEl = form.querySelector('[data-proof-photo-optout]');
        const payload = {
          page_handle: ctx ? ctx.dataset.handle : '',
          version: ctx ? ctx.dataset.version : '',
          email: emailEl ? emailEl.value.trim() : '',
          submitted_at: new Date().toISOString(),
          photo_opt_out: Boolean(optOutEl && optOutEl.checked), // Session 33: opt-out model (legitimate interest + right to object)
          options: blocks.map((block) => ({
            name: block.dataset.proofName || '',
            product_group: block.dataset.proofProduct || '',
            option_label: block.dataset.proofOptionLabel || '',
            proof_key: block.dataset.proofKey || '',
            decision: decisionOf(block),
            feedback: feedbackOf(block),
            signed_by: part(block, '[data-proof-signed-by]').value.trim(),
            attestation: part(block, '[data-proof-attestation]').checked,
          })),
        };
        form.querySelector('[data-zoho-email]').value = payload.email;
        form.querySelector('[data-zoho-data]').value = JSON.stringify(payload);
      }

      // Thank-you state after Zoho returns the client here with ?submitted=1.
      const successEl = document.querySelector('[data-proof-success]');
      if (successEl && new URLSearchParams(window.location.search).get('submitted') === '1') {
        form.hidden = true;
        successEl.hidden = false;
        successEl.focus();
        return;
      }

      const submitButton = form.querySelector('.proof-submit-btn');

      // Capture phase, on the button itself: this runs before any other
      // click listener on the page (including third-party scripts Shopify
      // may attach to the same button, e.g. reCAPTCHA) gets a chance to
      // react. stopImmediatePropagation ensures an invalid form can never
      // reach whatever handles the "real" submission.
      if (submitButton) {
        submitButton.addEventListener(
          'click',
          (event) => {
            const firstInvalid = validateForm();
            if (!firstInvalid) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          },
          true
        );
      }

      // Fallback for non-click submissions (e.g. pressing Enter in a field).
      form.addEventListener('submit', (event) => {
        const firstInvalid = validateForm();

        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        fillZohoFields();
        if (submitButton) submitButton.disabled = true;
      });

      // Re-enable the button if the client comes back with the browser's Back button.
      window.addEventListener('pageshow', () => {
        if (submitButton) submitButton.disabled = false;
      });

      function setBlockError(block, message) {
        const errorEl = part(block, '[data-proof-error]');
        block.classList.toggle('proof-approval__block--invalid', Boolean(message));
        errorEl.textContent = message;
        errorEl.hidden = !message;
      }

      function setGroupError(block, message) {
        const wrapper = block.closest('[data-proof-group-wrapper]');
        if (!wrapper) return;
        const errorEl = wrapper.querySelector('[data-proof-group-error]');
        wrapper.classList.toggle('proof-group--invalid', Boolean(message));
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.hidden = !message;
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
